import { baseApi } from "../../services/rtkApi/baseApi";

// Admin side of the store switch. The header and the store pages don't use these: they read
// through useStoreOpen (plain fetch, no auth header, remembered in localStorage).

export interface StoreSwitch {
  enabled: boolean;
  updatedAt: string | null;
}

const storeSwitchApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getStoreSwitch: builder.query<StoreSwitch, void>({
      query: () => "/store-switch",
    }),
    setStoreSwitch: builder.mutation<StoreSwitch, { enabled: boolean }>({
      query: (body) => ({ url: "/store-switch", method: "PUT", body }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(storeSwitchApi.util.updateQueryData("getStoreSwitch", undefined, () => data));
        } catch {
          // the page shows the error from the mutation itself
        }
      },
    }),
  }),
});

export const { useGetStoreSwitchQuery, useSetStoreSwitchMutation } = storeSwitchApi;
